import type { ReactNode } from "react";
import { UserAvatar } from "../../../components/User";
import type { BlacklistUserLike } from "./types";
import { formatAddedAt } from "./utils";

export type BlacklistUserListItemProps = {
  item: BlacklistUserLike;
  onPress?: () => void;
  actions?: ReactNode;
  className?: string;
};

export function BlacklistUserListItem({
  item,
  onPress,
  actions,
  className,
}: BlacklistUserListItemProps) {
  const reasonSummary = item.reason
    ? item.reason.length > 40
      ? item.reason.slice(0, 40) + "..."
      : item.reason
    : "无理由";

  return (
    <div
      className={`flex items-center gap-3 border-b border-default-100 px-4 py-3 last:border-b-0 ${className ?? ""}`}
    >
      <button
        type="button"
        className="flex min-w-0 flex-1 items-center gap-3 text-left"
        onClick={onPress}
        disabled={!onPress}
      >
        <UserAvatar avatar_url={item.avatar_url} size="sm" />
        <div className="min-w-0 flex-1 flex flex-col gap-0.5">
          <span className="text-sm text-gray-900 truncate">{item.nickname}</span>
          <span className="text-xs text-gray-400 truncate">{item.uid}</span>
          <span className="text-xs text-gray-500 truncate">{reasonSummary}</span>
          <span className="text-xs text-gray-400">{formatAddedAt(item.added_at)}</span>
        </div>
      </button>
      {actions ? <div className="shrink-0 flex items-center gap-1">{actions}</div> : null}
    </div>
  );
}
